import React, { useEffect, useState } from 'react'

import {
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { selectUsuarioSeleccionado } from '../../../redux/reducer/loginReducer'
import { generar_facturas_tutores, listado_pagos } from '../../../services/alumnos'

const estilos = `
    .lp-body { background-color: #f1f5f9; padding: 16px 32px; color: #1e293b; font-family: ui-sans-serif, system-ui, -apple-system, sans-serif; min-height: 100%; }
    .lp-container { width: 100%; }
    .lp-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
    .lp-titulo { margin: 0; font-size: 20px; font-weight: 600; }
    .lp-vacio { border-radius: 8px; background-color: #ffffff; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06); color: #64748b; }
    .lp-card { margin-bottom: 16px; overflow: hidden; border-radius: 8px; background-color: #ffffff; box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06); }
    .lp-summary { display: flex; cursor: pointer; list-style: none; align-items: center; justify-content: space-between; background-color: #1e293b; padding: 16px 20px; }
    .lp-summary::-webkit-details-marker { display: none; }
    .lp-summary:hover { background-color: #334155; }
    .lp-tutor { display: flex; align-items: center; font-size: 18px; font-weight: 600; color: #ffffff; margin: 0; }
    .lp-chevron { margin-right: 8px; height: 16px; width: 16px; flex-shrink: 0; color: #94a3b8; transition: transform 0.15s ease; }
    details[open] > .lp-summary .lp-chevron { transform: rotate(90deg); }
    .lp-tutor-id { color: #94a3b8; }
    .lp-total-badge { border-radius: 9999px; background-color: #475569; padding: 4px 12px; font-size: 14px; font-weight: 500; color: #ffffff; white-space: nowrap; }
    .lp-total-badge-facturado { background-color: #059669; }
    .lp-periodos > * + * { border-top: 1px solid #e2e8f0; }
    .lp-periodo { padding: 16px 20px; }
    .lp-periodo-header { margin-bottom: 12px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; }
    .lp-periodo-titulo-wrap { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
    .lp-periodo-titulo { font-size: 16px; font-weight: 600; color: #334155; margin: 0; }
    .lp-periodo-total { font-size: 14px; font-weight: 500; color: #64748b; }
    .lp-periodo-acciones { display: flex; align-items: center; gap: 12px; }
    .lp-badge { display: inline-flex; align-items: center; border-radius: 9999px; padding: 2px 10px; font-size: 12px; font-weight: 600; white-space: nowrap; }
    .lp-badge-facturado { background-color: #d1fae5; color: #047857; }
    .lp-badge-no-facturado { background-color: #fef3c7; color: #b45309; }
    .lp-facturado-detalle { margin: 0 0 12px 0; display: flex; align-items: center; gap: 16px; flex-wrap: wrap; font-size: 13px; color: #64748b; }
    .lp-facturado-detalle .lp-si { color: #047857; font-weight: 600; }
    .lp-facturado-detalle .lp-no { color: #b45309; font-weight: 600; }
    .lp-tablas { display: flex; align-items: flex-start; gap: 16px; flex-wrap: wrap; }
    .lp-tabla-bloque-actualidad { flex: 2 1 380px; min-width: 320px; }
    .lp-tabla-bloque-pago { flex: 1 1 280px; min-width: 280px; }
    .lp-tabla-subtitulo { margin: 0 0 6px 0; font-size: 13px; font-weight: 600; color: #475569; text-transform: uppercase; letter-spacing: 0.03em; }
    .lp-tabla-wrap { overflow-x: auto; border-radius: 4px; border: 1px solid #e2e8f0; }
    .lp-tabla { min-width: 100%; text-align: left; font-size: 14px; border-collapse: collapse; }
    .lp-tabla thead { background-color: #f8fafc; }
    .lp-tabla th { padding: 8px 16px; font-weight: 500; color: #475569; border-bottom: 1px solid #e2e8f0; }
    .lp-tabla td { padding: 8px 16px; border-bottom: 1px solid #f1f5f9; }
    .lp-tabla tbody tr:last-child td { border-bottom: none; }
    .lp-tabla tbody tr:hover { background-color: #f8fafc; }
    .lp-texto { color: #1e293b; }
    .lp-texto-suave { color: #64748b; }
    .lp-amber-medium { color: #d97706; font-weight: 500; }
    .lp-btn-pagar { display: inline-flex; align-items: center; border-radius: 4px; background-color: #059669; padding: 6px 12px; font-size: 12px; font-weight: 500; color: #ffffff; border: none; cursor: pointer; }
    .lp-btn-pagar:hover { background-color: #047857; }
    .lp-center { text-align: center; }
    .lp-right { text-align: right; }
    /* los Dialog de MUI usan z-index 1300 y dejan el Swal (1060) por detrás */
    .swal2-container { z-index: 2000 !important; }
`

const MESES_LABELS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
]

const fmt = (valor) => {
    return Number(valor ?? 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}

// periodo llega como "MM-YYYY"
const periodoLabel = (periodo) => {
    const [mes, anio] = String(periodo).split('-')
    const indice = parseInt(mes, 10) - 1
    if (isNaN(indice) || !MESES_LABELS[indice]) return String(periodo)
    return `${MESES_LABELS[indice]} ${anio}`
}

// clave ordenable "YYYY-MM" a partir de "MM-YYYY"
const periodoOrden = (periodo) => {
    const [mes, anio] = String(periodo).split('-')
    return `${anio}-${mes}`
}

// La API devuelve una lista plana en `info`; la agrupamos en tutor > periodo > grupos
const agruparTutores = (info) => {
    const tutores = {}
    ;(info ?? []).forEach(fila => {
        if (!tutores[fila.tutor_id]) {
            tutores[fila.tutor_id] = {
                id: fila.tutor_id,
                nombre: fila.tutor_nombre,
                periodos: {},
            }
        }
        const tutor = tutores[fila.tutor_id]
        if (!tutor.periodos[fila.periodo]) {
            tutor.periodos[fila.periodo] = []
        }
        tutor.periodos[fila.periodo].push(fila)
    })
    return Object.values(tutores).sort((a, b) => {
        const na = String(a.nombre ?? '').toLowerCase()
        const nb = String(b.nombre ?? '').toLowerCase()
        return na < nb ? -1 : na > nb ? 1 : 0
    })
}

const DialogModalListadoPagos = ({ openModal, setOpenModal }) => {
    const usuarioSeleccionado = useSelector(state => selectUsuarioSeleccionado(state))

    const [tutores, setTutores] = useState([])
    const [loading, setLoading] = useState(false)
    // periodos marcados para facturar, con clave "tutorId|periodo"
    const [seleccionados, setSeleccionados] = useState({})
    const [mostrarFacturado, setMostrarFacturado] = useState(
        () => localStorage.getItem(`listado_pagos_mostrar_facturado_${usuarioSeleccionado.id}`) === '1'
    )

    const handleChangeMostrarFacturado = (event) => {
        const checked = event.target.checked
        setMostrarFacturado(checked)
        localStorage.setItem(`listado_pagos_mostrar_facturado_${usuarioSeleccionado.id}`, checked ? '1' : '0')
    }

    const cargarListado = () => {
        setLoading(true)
        listado_pagos({ usuario_id: usuarioSeleccionado.id }).then(response => {
            const agrupados = agruparTutores(response?.info)
            setTutores(agrupados)

            // por defecto los periodos pendientes vienen marcados para facturar alumnos y material
            const iniciales = {}
            agrupados.forEach(tutor => {
                Object.entries(tutor.periodos ?? {}).forEach(([periodo, grupos]) => {
                    if (parseInt(grupos[0]?.periodo_facturado, 10) === 1) return
                    iniciales[`${tutor.id}|${periodo}`] = { alumnos: true, material: true }
                })
            })
            setSeleccionados(iniciales)

            setLoading(false)
        })
    }

    useEffect(() => {
        if (!openModal) return

        cargarListado()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal, usuarioSeleccionado.id])

    // campo: 'material' | 'alumnos'
    const handleToggleFacturar = (tutorId, periodo, campo) => {
        const clave = `${tutorId}|${periodo}`
        setSeleccionados(prev => ({
            ...prev,
            [clave]: { ...prev[clave], [campo]: !prev[clave]?.[campo] },
        }))
    }

    const handleGenerarFactura = () => {
        const periodosMarcados = []
        tutores.forEach(tutor => {
            periodosOrdenados(tutor).forEach(([periodo, grupos]) => {
                const seleccion = seleccionados[`${tutor.id}|${periodo}`]
                if (!seleccion?.material && !seleccion?.alumnos) return

                const facturacion = facturacionPeriodo(grupos)
                // lo no marcado se factura con importe 0
                periodosMarcados.push({
                    tutor_id: tutor.id,
                    periodo,
                    importe_alumno: seleccion.alumnos ? facturacion.importeAlumno : 0,
                    importe_material: seleccion.material ? facturacion.importeMaterial : 0,
                    max_alumnos_periodo: facturacion.maxAlumnos,
                    total: totalPeriodoSeleccionado(tutor.id, periodo, grupos),
                    grupos_id: grupos.map(g => g.grupo_id),
                })
            })
        })

        if (periodosMarcados.length === 0) {
            Swal.fire('No hay ningún periodo marcado para facturar')
            return
        }

        Swal.fire({
            title: `¿Generar facturas de los ${periodosMarcados.length} periodos marcados?`,
            showDenyButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                generar_facturas_tutores({
                    usuario_id: usuarioSeleccionado.id,
                    periodos: periodosMarcados,
                }).then(response => {
                    if (response === undefined) {
                        Swal.fire('No se han podido generar las facturas')
                        return
                    }
                    Swal.fire('Facturas generadas')
                    cargarListado()
                })
            }
        })
    }

    const handleProcesarPago = (tutorId, periodo, grupoId) => {
        if (!window.confirm('¿Marcar como pagado a tutor este grupo de este periodo?')) return
        // TODO: llamar al servicio de procesar pago (procesar_pago=1&tutor_id&periodo&grupo_id)
        console.log('procesar_pago', { tutor_id: tutorId, periodo, grupo_id: grupoId })
    }

    // la parte de alumnos se suma por grupo; el material se paga una sola vez por periodo
    const totalPeriodo = (grupos) => {
        return grupos.reduce((t, g) => t + Number(g.total_pago_tutor_grupo ?? 0), 0)
            + Number(grupos[0]?.total_pago_material_tutor ?? 0)
    }

    // total del periodo contando solo los conceptos marcados para facturar;
    // los periodos ya facturados muestran siempre el total completo
    const totalPeriodoSeleccionado = (tutorId, periodo, grupos) => {
        if (parseInt(grupos[0]?.periodo_facturado, 10) === 1) return totalPeriodo(grupos)

        const seleccion = seleccionados[`${tutorId}|${periodo}`]
        const totalAlumnos = seleccion?.alumnos
            ? grupos.reduce((t, g) => t + Number(g.total_pago_tutor_grupo ?? 0), 0)
            : 0
        const totalMaterial = seleccion?.material
            ? Number(grupos[0]?.total_pago_material_tutor ?? 0)
            : 0
        return totalAlumnos + totalMaterial
    }

    // La facturación viene a nivel tutor+periodo, así que todas las filas
    // (grupos) del mismo periodo comparten los mismos valores
    const facturacionPeriodo = (grupos) => {
        const fila = grupos[0] ?? {}
        return {
            facturado: parseInt(fila.periodo_facturado, 10) === 1,
            tutorizacion: parseInt(fila.tutorizacion_facturada, 10) === 1,
            material: parseInt(fila.material_facturado, 10) === 1,
            alumnosFacturados: parseInt(fila.alumnos_facturados, 10) || 0,
            facturaId: fila.factura_id ?? null,
            maxAlumnos: parseInt(fila.max_alumnos_periodo, 10) || 0,
            importeAlumno: fila.importe_alumno_tutor,
            importeMaterial: fila.importe_material_tutor,
        }
    }

    // orden cronológico ascendente por periodo
    const periodosOrdenados = (tutor) => {
        return Object.entries(tutor.periodos ?? {}).sort(([a], [b]) => {
            const ka = periodoOrden(a)
            const kb = periodoOrden(b)
            return ka < kb ? -1 : ka > kb ? 1 : 0
        })
    }

    const todoFacturado = (tutor) => {
        return periodosOrdenados(tutor).every(([, grupos]) => facturacionPeriodo(grupos).facturado)
    }

    // total del tutor contando solo los periodos pendientes de facturar
    // y, dentro de cada uno, solo los conceptos marcados
    const totalPendienteTutor = (tutor) => {
        return periodosOrdenados(tutor)
            .filter(([, grupos]) => !facturacionPeriodo(grupos).facturado)
            .reduce((t, [periodo, grupos]) => t + totalPeriodoSeleccionado(tutor.id, periodo, grupos), 0)
    }

    return (
        <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            maxWidth={false}
            fullWidth
            PaperProps={{
                style: {
                    width: '95%',
                    height: '95%',
                    maxWidth: '95%',
                    maxHeight: '95%',
                },
            }}
        >
            <DialogTitle disableTypography style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h6">Listado de pagos</Typography>
                <Button variant="contained" color="primary" onClick={handleGenerarFactura}>
                    Generar facturas
                </Button>
            </DialogTitle>
            <DialogContent style={{ padding: 0 }}>
                <style>{estilos}</style>
                <div className="lp-body">
                    <div className="lp-container">
                        <div className="lp-header">
                            <h1 className="lp-titulo">Cuotas pendientes de pago a tutores</h1>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mostrarFacturado}
                                        onChange={handleChangeMostrarFacturado}
                                        color="primary"
                                    />
                                }
                                label="Mostrar facturado"
                            />
                        </div>

                        {loading ? (
                            <div className="lp-vacio">Cargando...</div>
                        ) : (tutores ?? []).length === 0 ? (
                            <div className="lp-vacio">No hay cuotas pendientes de pago.</div>
                        ) : (
                            tutores.map(tutor => {
                                const facturadoCompleto = todoFacturado(tutor)
                                const periodosVisibles = periodosOrdenados(tutor)
                                    .filter(([, grupos]) => mostrarFacturado || !facturacionPeriodo(grupos).facturado)

                                return (
                                <details className="lp-card" open key={tutor.id}>
                                    <summary className="lp-summary">
                                        <h2 className="lp-tutor">
                                            <svg className="lp-chevron" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10 7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02z" clipRule="evenodd" />
                                            </svg>
                                            <span>
                                                <span className="lp-tutor-id">[{tutor.id}]</span> {tutor.nombre}
                                            </span>
                                        </h2>
                                        {facturadoCompleto ? (
                                            <span className="lp-total-badge lp-total-badge-facturado">Todo facturado</span>
                                        ) : (
                                            <span className="lp-total-badge">Total: {fmt(totalPendienteTutor(tutor))} €</span>
                                        )}
                                    </summary>

                                    <div className="lp-periodos">
                                        {periodosVisibles.length === 0 && (
                                            <div className="lp-periodo lp-texto-suave">
                                                Todos los periodos de este tutor están facturados.
                                            </div>
                                        )}
                                        {periodosVisibles
                                            .map(([periodo, grupos]) => {
                                                const facturacion = facturacionPeriodo(grupos)
                                                return (
                                                <div className="lp-periodo" key={periodo}>
                                                    <div className="lp-periodo-header">
                                                        <div className="lp-periodo-titulo-wrap">
                                                            <h3 className="lp-periodo-titulo">{periodoLabel(periodo)}</h3>
                                                            {facturacion.facturado ? (
                                                                <span className="lp-badge lp-badge-facturado">
                                                                    Facturado{facturacion.facturaId ? ` · Factura #${facturacion.facturaId}` : ''}
                                                                </span>
                                                            ) : (
                                                                <span className="lp-badge lp-badge-no-facturado">No facturado</span>
                                                            )}
                                                        </div>
                                                        <div className="lp-periodo-acciones">
                                                            {totalPeriodo(grupos) > 0 && !facturacion.facturado && (
                                                                <>
                                                                    <FormControlLabel
                                                                        style={{ margin: 0 }}
                                                                        control={
                                                                            <Checkbox
                                                                                color="primary"
                                                                                size="small"
                                                                                checked={!!seleccionados[`${tutor.id}|${periodo}`]?.alumnos}
                                                                                onChange={() => handleToggleFacturar(tutor.id, periodo, 'alumnos')}
                                                                            />
                                                                        }
                                                                        label="Facturar alumnos"
                                                                    />
                                                                    <FormControlLabel
                                                                        style={{ margin: 0 }}
                                                                        control={
                                                                            <Checkbox
                                                                                color="primary"
                                                                                size="small"
                                                                                checked={!!seleccionados[`${tutor.id}|${periodo}`]?.material}
                                                                                onChange={() => handleToggleFacturar(tutor.id, periodo, 'material')}
                                                                            />
                                                                        }
                                                                        label="Facturar material"
                                                                    />
                                                                </>
                                                            )}
                                                            <span className="lp-periodo-total">{fmt(totalPeriodoSeleccionado(tutor.id, periodo, grupos))} €</span>
                                                        </div>
                                                    </div>

                                                    {facturacion.facturado && (
                                                        <div className="lp-facturado-detalle">
                                                            <span>
                                                                Tutorización: {facturacion.tutorizacion
                                                                    ? <span className="lp-si">Sí ({facturacion.alumnosFacturados} alumnos)</span>
                                                                    : <span className="lp-no">No</span>}
                                                            </span>
                                                            <span>
                                                                Material: {facturacion.material
                                                                    ? <span className="lp-si">Sí</span>
                                                                    : <span className="lp-no">No</span>}
                                                            </span>
                                                        </div>
                                                    )}

                                                    <div className="lp-tablas">
                                                        <div className="lp-tabla-bloque-actualidad">
                                                            <h4 className="lp-tabla-subtitulo">Actualidad</h4>
                                                            <div className="lp-tabla-wrap">
                                                                <table className="lp-tabla">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Grupo</th>
                                                                            <th className="lp-center">Alumnos con cuota pagada</th>
                                                                            <th className="lp-center">Alumnos actuales</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {[...grupos]
                                                                            // alfabético por nombre de grupo sin distinguir mayúsculas
                                                                            .sort((a, b) => {
                                                                                const na = String(a.grupo_nombre ?? '').toLowerCase()
                                                                                const nb = String(b.grupo_nombre ?? '').toLowerCase()
                                                                                return na < nb ? -1 : na > nb ? 1 : 0
                                                                            })
                                                                            .map(grupo => (
                                                                                <tr key={grupo.grupo_id}>
                                                                                    <td className="lp-texto">{grupo.grupo_nombre}</td>
                                                                                    <td className="lp-center lp-texto">{parseInt(grupo.alumnos_que_han_pagado_cuota, 10) || 0}</td>
                                                                                    <td className="lp-center lp-texto-suave">{parseInt(grupo.alumnos_actuales_grupo, 10) || 0}</td>
                                                                                </tr>
                                                                            ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="lp-tabla-bloque-pago">
                                                            <h4 className="lp-tabla-subtitulo">Pago</h4>
                                                            <div className="lp-tabla-wrap">
                                                                <table className="lp-tabla">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="lp-right">Importe/alumno</th>
                                                                            <th className="lp-right">Importe material</th>
                                                                            <th className="lp-center">Máx. alumnos del periodo</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="lp-right lp-texto">{fmt(facturacion.importeAlumno)} €</td>
                                                                            <td className="lp-right lp-texto">{fmt(facturacion.importeMaterial)} €</td>
                                                                            <td className="lp-center lp-texto">{facturacion.maxAlumnos}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )
                                            })}
                                    </div>
                                </details>
                                )
                            })
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default DialogModalListadoPagos
